import { render, staticRenderFns } from "./CardPropertyObject.vue?vue&type=template&id=2b2793b2&scoped=true&"
import script from "./CardPropertyObject.vue?vue&type=script&lang=js&"
export * from "./CardPropertyObject.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyObject.vue?vue&type=style&index=0&id=2b2793b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2793b2",
  null
  
)

export default component.exports
import {QSelect,QChip,QBtn,QTooltip,QField} from 'quasar'
component.options.components = Object.assign({QSelect,QChip,QBtn,QTooltip,QField}, component.options.components || {})
